export default __webpack_public_path__ + "static/media/partner_signup_background_mobile.fcbf967c.jpg";